import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import * as types from '@reserve/store/types'
import { EnumCalendarViewType } from '../types';

import { FullMasterTemplate} from '@appbase/templates'
import { LeftMenu } from '@appbase/components/common';

@Component ({
    components: {
        FullMasterTemplate,
        LeftMenu
    },

    computed: mapGetters({
        isLoading: types.CALENDAR_LOADING,
        calendarMode: types.CALENDAR_VIEWMODE   
    })
})
export default class ReserveMaster extends Vue {
    isLoading!: boolean;   
    calendarMode!: EnumCalendarViewType;
    
    maxContent: boolean = false;

    @Watch('$route.fullPath')    
    @Watch('calendarMode')
    onRouteChanged(newVal: string) {
        if(this.$route.name === 'reserve-day' && this.calendarMode == EnumCalendarViewType.Merge) {
            this.maxContent = true;
        } else {
            this.maxContent = false;
        }
    }   

    created() {       
        this.onRouteChanged(this.$route.fullPath);
    }
}
